import axios from "_u/axios"

// 发票管理查询列表
export const invoiceList = (body) => {
    return axios.post("api/finance/invoice/list", body)
}

// 发票管理查看明细
export const invoiceView = (id) => {
    return axios.post("api/finance/invoice/view", { id })
}

// 新增发票管理
export const invoiceAdd = (body) => {
    return axios.post("api/finance/invoice/add", body)
}

// 修改发票管理
export const invoiceUpdate = (body) => {
    return axios.post("api/finance/invoice/update", body)
}

// 删除发票管理
export const invoiceDelete = (id) => {
    return axios.post("api/finance/invoice/delete", { id })
}